<style scoped lang='less'>
.dialog-box {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
}
.isdialog-enter-active,
.isdialog-leave-active {
    transition: all ease 0.5s;
}
.isdialog-enter,
.isdialog-leave-to {
    transform: scale(0);
    opacity: 0;
}
.content {
    height: 400px;
    width: 600px;
    background: white;
    transform-origin: 50%, 50%;
    display: flex;
}
.header {
    padding: 15px 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid rgba(160, 160, 160, 0.2);
    > img {
        width: 25px;
        height: 25px;
    }
}
.tag-list-container {
    padding: 10px;
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    height: 290px;
    overflow: hidden;
    overflow-y: scroll;
    .tag-box {
        cursor: pointer;
        margin-right: 20px;
        margin-bottom: 8px;
        border-radius: 15px;
        height: 30px;
        display: inline-block;
        text-align: center;
        line-height: 30px;
        padding: 0 15px;
        font-size: 10px;
        border: 1px solid rgba(187, 203, 223, 1);
        color: rgba(187, 203, 223, 1);
        background-color: #fff;
    }
    .active-tag-box {
        cursor: pointer;
        color: #fff;
        background-color: rgba(206, 0, 40, 1);
        border: 1px solid rgba(206, 0, 40, 1);
    }
}
.btn-container {
    position: relative;
    display: flex;
    justify-content: flex-end;
    padding: 0 20px;
    .cancel {
        cursor: pointer;
        width: 130px;
        height: 40px;
        line-height: 40px;
        border-radius: 3px;
        color: rgba(206, 0, 40, 1);
        border: 1px solid rgba(206, 0, 40, 1);
        background-color: #fff;
        margin-right: 20px;
    }
    .submit {
        cursor: pointer;
        width: 130px;
        height: 40px;
        line-height: 40px;
        border-radius: 3px;
        color: #fff;
        background-color: rgba(206, 0, 40, 1);
    }
}
</style>
<template>
  <div class='dialog-box' v-show='show' @click.stop='close'>
    <transition name='isdialog'>
      <div class='content' v-if='show' @click.stop=''>
        <div>
          <div class='header'>
            <span>{{'行业筛选'|language}}</span>
            <img @click.stop='close' src="http://static.unicornselected.com/6a5c07c0-69a4-11e9-9dc8-4705613d3efb.png" alt="">
          </div>
          <div class='tag-list-container'>
            <span :class="[item.isActive?'tag-box active-tag-box':'tag-box']" @click='selectedTagHandler(item,index)' v-for="(item,index) in tags" :key="item.id">
              {{en?item.en: item.name }}
            </span>
          </div>
          <div class='btn-container'>
            <div class='cancel' @click='close'>{{'取消'|language}}</div>
            <div class='submit' @click='submit'>{{'确定'|language}}</div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import { HttpClient } from '../../util/http';
export default {
    components: {},
    data() {
        return {
            fatherData: null,
            show: false,
            form: {},
            loading: false,
            selectedTagIdList: new Map(),
            tags: [],
        };
    },

    methods: {
        createtagMap() {
            this.selectedTagIdList = new Map();
        },
        submit() {
            this.show = false;
            this.$emit('close-tags');
        },
        close() {
            this.$emit('close-tags');
            this.show = false;
            this.selectedTagIdList = new Map();
            this.$emit('company-tag', []);
            this.$emit('update:cleartag', []);
        },
        selectedTagHandler(item, index) {
            if (!item.isActive) {
                item.isActive = true;
                this.$set(this.tags, index, item);
                this.selectedTagIdList.set(item._id, {
                    cn: item.ch,
                    en: item.en,
                });
            } else {
                item.isActive = false;
                this.$set(this.tags, index, item);
                this.selectedTagIdList.delete(item._id);
            }
            let companyTagMulti = Array.from(this.selectedTagIdList);

            this.$emit('company-tag', companyTagMulti);
        },
    },
};
</script>
